export enum ContentTypes {
  ImagePNG = "image/png",
  ImageXPNG = "image/x-png",
  ImageJPG = "image/jpg",
  ImageJPEG = "image/jpeg",
  ImagePJPG = "image/pjpeg",
  ImageBMP = "image/bmp",
  ImageHEIC = "image/heic",
  ImageHEIF = "image/heif",
  ApplicationPDF = "application/pdf",
  Text = "text/plain",
  TextXML = "text/xml",
  Zip = "application/zip",
  XZip = "application/x-zip-compressed",
  CSV = "text/csv",
  MsCSV = "application/vnd.ms-excel",
  SIE = "",
  ApplicationJson = "application/json",
  ApplicationOctetStream = "application/octet-stream",
  ApplicationEncryptedPgp = "application/pgp-encrypted",
  ApplicationPgpSignature = "application/pgp-signature",
  ApplicationPgpKeys = "application/pgp-keys",
  Html = "text/html",
  Docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  Doc = "application/msword",
  Xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}
